import { css } from '@emotion/react';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { has, keys } from 'sdk';

import { useSDK } from '../../../../app';
import { styled } from '../../../../styled';
import { Tooltip } from '../errorLabel';
import { Label } from '../label';
import { AttachmentsPreviewList } from './attachmentsPreviewList';
import { AttachmentError } from './attachmentsPreviewList/attachmentError';
import { commonStyles, Interface, useLogic } from './common';
import { MessageFieldButtonsPrechat } from './messageFieldButtons/prechat';
import { Suggestions } from './suggestions';
import { TextArea } from './textarea/textarea';

const DEFAULT_MESSAGE_FIELD_LABEL = 'Ваше сообщение';

const Component = observer(
	({
		className,
		onSendClick: onSendClickProp,
		onChange: onChangeProp,
		value,
		onSuggestionSelect,
		error,
		disabled,
		withAttachments = true,
	}: Interface): ReactElement => {
		const { suggestionsStore, welcomeDataStore } = useSDK();
		const {
			attachmentsInputRef,
			onKeyPress,
			onAttachmentLoad,
			onChange,
			setShowEmoji,
			showEmoji,
			scrollbar,
			textarea,
			onEmojiPick,
		} = useLogic(onSendClickProp, withAttachments, onChangeProp, value);
		return (
			<>
				{(has(suggestionsStore.suggestions, value) &&
					keys(suggestionsStore.suggestions[value]).length &&
					onSuggestionSelect && (
						<Suggestions
							onSuggestionSelect={onSuggestionSelect}
							suggestions={suggestionsStore.suggestions[value]}
						/>
					)) ||
					null}
				<div>
					<Label
						text={welcomeDataStore.data?.showcase.messagePlaceholder || DEFAULT_MESSAGE_FIELD_LABEL}
						hasError={!!error}
						required={false}
					/>
					<div className={className}>
						{error && <Tooltip className="error-tooltip">{error}</Tooltip>}

						<MessageFieldButtonsPrechat
							onEmojiPick={onEmojiPick}
							setShowEmoji={setShowEmoji}
							emojiPanelActive={showEmoji}
							withAttachments={withAttachments}
							onAttachmentClick={(): void => attachmentsInputRef.current?.click()}
						>
							<TextArea
								onKeyPress={disabled ? (): void => void 0 : onKeyPress}
								onChange={onChange}
								value={value}
								textareaRef={textarea}
								isPrechat
								scrollbar={scrollbar}
							/>
						</MessageFieldButtonsPrechat>

						{withAttachments && (
							<input
								className="hidden_input"
								accept={welcomeDataStore.data?.allowedExtensions.map((ext) => '.' + ext).join(',')}
								onChange={onAttachmentLoad?.onAttachmentLoad}
								ref={attachmentsInputRef}
								type="file"
							/>
						)}
					</div>
				</div>
				<AttachmentError />
				<AttachmentsPreviewList attachmentLoadHandler={onAttachmentLoad || undefined} />
			</>
		);
	}
);

const MessageFieldPrechat = styled(Component)(
	commonStyles,
	css`
		height: auto;
		padding: 8px;
	`
);

export { MessageFieldPrechat };
